
  import {Component, Vue, Watch} from "vue-property-decorator";
  import Form1 from "@/views/scanforoutbound_getoff/Form1.vue";
  import Form2 from "@/views/scanforoutbound_getoff/Form2.vue";
  import Scan from "@/views/components/Scan/Scan.vue";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import TableHeader from "@/views/scanforoutbound_getoff/TableHeader.vue";
  import Counting from "@/views/components/Counting/Counting.vue";
  import RankingList from "@/views/components/RankingList/index.vue";
  import config from "./config";
  import {CountingVo} from "@/views/components/Counting/CountingVo";
  import {ApiQueryType, UploadStateEnum} from "@/common/glboalconstant";
  import {SoundPlayer} from "@/common/SoundPlayer";
  import {QueueGetOffEntity} from "@/common/Vo/QueueGetOffEntity";
  import Enumerable from "linq";
  import fa from "element-ui/src/locale/lang/fa";
  import el from "element-ui/src/locale/lang/el";
  import DEFAULT_TIMEOUT_INTERVAL = jasmine.DEFAULT_TIMEOUT_INTERVAL;
  import {parseTime, removeItem} from "@/utils";
  import en from "element-ui/src/locale/lang/en";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";
  import ScanForOutboundGetoffSahpe1 from "@/views/scanforoutbound_getoff/ScanForOutboundGetoffSahpe1.vue";
  import ScanForOutboundGetoffSahpe2 from "@/views/scanforoutbound_getoff/ScanForOutboundGetoffSahpe2.vue";
  import { LogHelper } from "@/common/LogHelper";
  import { ScanforOutBound_GetOffModule } from "@/store/modules/store_scanforoutbound_getoff";
  import { SystemConfigModule } from "@/store/modules/store_systemconfig";
  import {checkCodesAndType, clientOptLog, cloudPress} from "@/api/service";
  import {debug} from "webpack";
  import ReconnectingWebSocket from "reconnecting-websocket";
  import {ReturnMsg} from "@/views/rfid/TaskItem";
  import dayjs from "dayjs";
  import {BizUtil} from "@/utils/biz-util";


  @Component({
    name: "scanforoutbound_getoff",
    components: {
      ScanForOutboundGetoffSahpe2,
      ScanForOutboundGetoffSahpe1,
      RankingList,
      Counting,
      TableHeader,
      YtoTable,
      Scan,
      Form2,
      Form1
    }
  })
  export default class extends Vue {
    timer: NodeJS.Timeout;
    @Watch('f1', {deep: true})
    private setForm(): void {
      var val = arguments[0]
      var oldval = arguments[1];
      console.log(val)
      this.setInputForm()
    }

    @Watch('f1.NextWebPoint')
    private clearNextWebPointName(): void {
      if (!this.f1.NextWebPoint) {
        this.f1.NextWebPointName = '';
      }
    }

    @Watch("$store.state.store_scanforoutbound_getoff.autoCreateCarCode")
    private setAutoCreateCarCodeState(v): void {
      if (obj_ScanForOutbound_GetOff && obj_ScanForOutbound_GetOff.setAutoCreateCarCodeState) {
        obj_ScanForOutbound_GetOff.setAutoCreateCarCodeState(v)
      }
    }

    @Watch('NumberInCarValue')
    private NumberInCarValueChange(val): void {
      this.CountVo.allCount = val
    }
    get NumberInCarValue(){
      return ScanforOutBound_GetOffModule.numberInCar;
    }
    set NumberInCarValue(value) {
      ScanforOutBound_GetOffModule.setNumberInCarValue(value);
    }
    public ranklistdata: rankListModel = {
      avgEfficiency: "0",
      lastHourAvgEfficiency: "0",
      avgEfficiencyRank: "0",
      frequencyRank: "0",
      wholeTopEfficiency: "0"
    };

    public ranklistupdatecallback(dic) {
      this.ranklistdata = dic;
    }


    private created(): void {
    }

    //落格上传用
    private DataQueue = [];
    //存储单号及其格口三段码
    private codeAndLatticeThreeCode = [];
    private useShape1: boolean = false;

    private currentDwsCode: string = '';
    private ws: WebSocket = null;
    private ws2: WebSocket = null;
    // private msgWs: WebSocket = null;
    private imageItems = [];

    private setFocus() {
      console.log('输入框自动焦点');
      let scan: any = this.$refs.shape2;
      scan.setFocus();
    }
    private globalConfig: any = {};
    private loginData:any;
    private tableHeaders=config.tableHeader;



    public noReadNum = 0 /*无读件*/;
    public noLittleNum = 0 /*无格口件*/;
    public littleNum = 0 /*有格口件*/;
    public manyCodeNum = 0 /*多条码件*/;
    public overTimeNum = 0; //超时，无格口件



    private mounted(): void {
      console.log('开始下车页面')
      let _this = this;
      if (typeof obj_GlobalData_Core !== "undefined") {
        this.globalConfig = SystemConfigModule.globalData;
        SystemConfigModule.setCurrentDeviceType(this.globalConfig.CurrentDeviceType);
      }
      if (typeof obj_ScanForOutbound_GetOff !== "undefined") {
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setErrorMessage', (error) => {
          _this.setFocus();
          _this.msg = error;
          ScanforOutBound_GetOffModule.setErrorMessage(error);
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetDwsCurrentCode', (ytoCode) => {
          _this.currentDwsCode = ytoCode;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setFocus', (ytoCode) => {
          console.log('setFocus');
          _this.setFocus();
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetTaskWsPort', (port) => {
          console.log('注册ws');
          _this.ws = new WebSocket(`ws://localhost:50999`);
          _this.ws.onmessage = function (e) {
            if (!e.data) {
              return;
            }
            var obj = JSON.parse(e.data);
            if (obj.ActionName === "WebSocketImageAction") {
              console.log("收到图片" + e.data);
              var data = JSON.parse(obj.Parameter);
              var url = 'data:image/png;base64,' + data.ImgBuffer;
              var imgDom: any = document.getElementById('dashboardModel.captureimage');
              imgDom.src = url;
            }
            if (obj.ActionName === 'summaryClose') {
              var data = JSON.parse(obj.Parameter);
              _this.summaryClose(data.weight, data.num)
            }
          };
          _this.ws.onopen = function () {
            var json = JSON.stringify({ActionName: 'RegisterImageUpload', Parameter: ''});
            _this.ws.send(json);
            console.log("注册图片显示事件:" + json)
          }
        });
        if (typeof obj_ScanForOutbound_GetOff.getDataList === "undefined") {
          obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetTaskDwsWsPort', _this.SetTaskWsPort);
        }
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('selectScanArea', () => {
          // debugger
          let input_select: any = document.getElementById('input_scancode_id');
          input_select.select()
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setScanAreaText', (value) => {
          _this.ytoCode = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('InsertDataToListFun', (entity: QueueGetOffEntity[], weight, num) => {
          // this.tableItems.splice(0, 0, entity);
          // if (this.tableItems.length > 50) {
          //   this.tableItems.pop();
          // }

          _this.tableItems = entity;
          _this.summaryClose(weight, num)
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('InsertDetailDataToList', (items: ExpDetail_Array_Data[]) => {
          console.log('InsertDetailDataToList:' + JSON.stringify(items));
          _this.tableItems2.push(...items);
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetSentArrivingCount', (notSentCount: number, notArrivingCount: number) => {
          _this.sendCountVo.notSentCount = notSentCount;
          _this.sendCountVo.notArrivingCount = notArrivingCount;
          _this.sendCountVo.visible = true;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setScanAreaFocus', () => {
          // _this.$refs.scan.input_setFocus();
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setWeight', (value) => {
          _this.f1.PackageSize.Weight = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setOptAreaRequired', (value: boolean) => {
          _this.f1.setOptAreaRequired = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setInputLWHDisable', (value: boolean) => {
          if (ScanforOutBound_GetOffModule.lockLengthWidthHeight) {
            //如果界面锁定了长宽高，那么不根据客户端的请求来处理，此处跳过不做操作
          } else {
            //根据客户端的返回值判断是否放开操作
            _this.f1.LWHDisable = !value;
          }
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetNumberInCar', (value: number) => {
          _this.CountVo.allCount = value;
          ScanforOutBound_GetOffModule.setNumberInCarValue(value);
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('ShowErrorMsg', (msg) => {
          console.log('show error msg:' + msg);
          _this.$message.error(msg)
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('ShowSuccessMsg', (msg) => {
          console.log('show error msg:' + msg);
          _this.$message.success(msg)
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setInputLWH', (length: number, width: number, height: number) => {
          _this.f1.PackageSize.Length = length;
          _this.f1.PackageSize.Width = width;
          _this.f1.PackageSize.Height = height;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('getInputForm', () => {
          return this.f1;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('IsAutoGetNextOrgCode', () => {
          return this.f1.AutoGetNextOrgCode;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetNextWebPointEnable', (value) => {
          this.f1.NextWebPointDisable = !value;
          _this.setForm()
        });
        // obj_ScanForOutbound_GetOff.registerJavaScriptCallback('ShowImage', (src: String) => {
        //   this.f1.NextWebPointDisable = !value;
        // });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('DeviceStateRefreshState', (datas) => {
          console.log("设备状态");
          console.log(datas);
          _this.deviceItems = [];
          _this.deviceItems = datas;

          console.log(_this.deviceItems);
        });
        obj_ScanForOutbound_GetOff.regist_ranklistupdate(this.ranklistupdatecallback);
        console.log('获取是否可以做上车')
        if (obj_ScanForOutbound_GetOff.getHasUpload){
          try {
            let b = obj_ScanForOutbound_GetOff.getHasUpload();
            if (b){
              obj_ScanForOutbound_GetOff.registerJavaScriptCallback('DropLatticeDataUpload', (json) => {
                debugger
                console.log(json)
                var data = JSON.parse(json);
                _this.DropLatticeDataUpload(data)
              });
              this.tableHeaders=this.config.tableHeader2
            }
          }
          catch (e) {
            console.log(e)
          }
        }

        this.loginData = SystemConfigModule.loginData;


        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('DropLatticeDataUpload', (json) => {
          console.log(json)
          var data = JSON.parse(json);
          _this.DropLatticeDataUpload(data)
        });
        console.log('获取是否可以做上车')
        if (obj_ScanForOutbound_GetOff.getHasUpload){
          try {
            let b = obj_ScanForOutbound_GetOff.getHasUpload();
            if (b){
              this.tableHeaders=this.config.tableHeader2
            }
          }
          catch (e) {
            console.log(e)
          }
        }

        this.loginData = SystemConfigModule.loginData;

        function clearData(f1: OnCodeGetReqVo) {
          f1.PacketCode = '';
          f1.PackageSize.Weight = 0.0;
          f1.PackageSize.InputWeight = 0.0;
          f1.PackageSize.VolumnWeight = 0.0;

          if (SystemConfigModule.currentDeviceType == 4 && ScanforOutBound_GetOffModule.lockLengthWidthHeight) {
            LogHelper.Console("下车页面,设备类型为4(普通扫描)且选择了锁定长宽高,则不清空");
          } else {
            if (!f1.PackageSize.HeightLock) {
              f1.PackageSize.Height = 0;
            }
            if (!f1.PackageSize.WidthLock) {
              f1.PackageSize.Width = 0;
            }
            if (!f1.PackageSize.LengthLock) {
              f1.PackageSize.Length = 0;
            }
          }

          if (!f1.NextWebPointLock) {
            f1.NextWebPoint = '';
            f1.NextWebPointName = '';
          }
        }

        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setClearData', () => {
          clearData(this.f1);
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('getOperationArea', () => {
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setOperationArea', (value) => {
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('getPacketCode', () => {
          return _this.f1.PacketCode;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setPacketCode', (value) => {
          return _this.f1.PacketCode = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setNextWebPoint', (value) => {
          _this.f1.NextWebPoint = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('getNextWebPoint', () => {
          return _this.f1.NextWebPoint;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('getRecvType', () => {
          return _this.f1.RecvType;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setRecvType', (value) => {
          _this.f1.RecvType = value;
          _this.$nextTick(() => {
            _this.setFocus();
          });
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setRecvTypes', (values, defaultValue) => {
          _this.f1.RecvType = defaultValue;
          _this.ioTypes = values;
          console.log(_this.ioTypes);
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('IsNeedVoiceLayerFunc', (value) => {
          console.log('启用声音分层结果：' + value);
          _this.f1.IsNeedVoiceLayerDisable = !value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setCarSignNum', (value) => {
          // if (ScanforOutBound_GetOffModule.autoCreateCarCode) {
          //   setTimeout(() => {
          //     ScanforOutBound_GetOffModule.setErrorMessage("车签为自动生成，无法手动修改");
          //   }, 100);
          // } else {
          if (value.length ==20 && value.startsWith("CQ")) {
          } else {
            ScanforOutBound_GetOffModule.setAutoCreateCarCode(false);
          }
          _this.f1.CarSignNum = value;
          _this.CountVo.currentCount = 0;
          ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode(null);
          // }
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('GetCarSignNum', (b) => {
          return _this.f1.CarSignNum;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetIsAutoGetNextOrgCode', (b: boolean) => {
          return _this.f1.AutoGetNextOrgCode = b;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('getNextWebPointName', () => {
          return _this.f1.NextWebPointName;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('GetIsCarcodeLocked', () => {
          return true
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetPutinWeightEnableFunc', (value: boolean) => {
          this.f1.PackageSize.InputWeightDisable = !value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetPutinWeight', (value: number) => {
          this.f1.PackageSize.InputWeight = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('setNextWebPointName', (value) => {
          _this.f1.NextWebPointName = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('getIsNeedVoiceLayer', () => {
          return _this.f1.IsNeedVoiceLayer;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('UploadLoadCallback', (code: string, status: boolean, msg: string, nextWebPointName: string) => {
          this.UploadCallback(code, status, msg, nextWebPointName)
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('summaryClose', this.summaryClose);
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('orderCheckFun', () => {

        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetScanAreaTextError', this.setScanAreaTextErrorFun);
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetVolumnWeight', (weight: number) => {
          _this.f1.PackageSize.VolumnWeight = weight;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetBtnSaveEnable', (value: boolean) => {
          _this.buttonVo.SaveButtonDisable = !value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetModifySuccess', (code: string) => {
          _this.msg = '修改成功';
          ScanforOutBound_GetOffModule.setErrorMessage('修改成功');
          let c = Enumerable.from(this.tableItems);
          let entity = c.firstOrDefault(f => f.code === code);
          entity.ScanTime = new Date();
          entity.NextWebPoint = this.f1.NextWebPoint;
          entity.NextWebPointName = this.f1.NextWebPointName;
          entity.weight = this.f1.PackageSize.Weight;
          entity.PutinWeight = this.f1.PackageSize.InputWeight;
          entity.length = this.f1.PackageSize.Length;
          entity.height = this.f1.PackageSize.Height;
          entity.width = this.f1.PackageSize.Width;
          this.ytoCode = '';
          clearData(this.f1)
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetModifyError', (code: string, value: string) => {
          _this.msg = '修改失败，' + value;
          ScanforOutBound_GetOffModule.setErrorMessage('修改失败，' + value);
          let c = Enumerable.from(_this.tableItems);
          let entity = c.firstOrDefault(f => f.code === code);
          entity.UploadStateCode = 4;
          clearData(this.f1)
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetDeleteSuccess', () => {
          let row = _this.currentDelRow;
          if (row) {
            removeItem(_this.tableItems, row);
          }
        });
        obj_ScanForOutbound_GetOff.vueLoaded();
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetTableWLH',(code,length,width,height)=>{
          _this.VolInfoCallback(code,length,width,height);
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetCarCodeLockPromot',()=>{
          this.$message.error("车签录入失败，如需更换车签，请去除锁定按钮后重新录入！");
        });
      }
      if (typeof obj_ScanForOutbound_GetOff.getDataList !== "undefined") {
        _this.autoGetData();
      }
          this.loginData = SystemConfigModule.loginData;
      //新增上传落格回传上车数据处理线程,add by klm 20220909
      // this.timer = setInterval(() => {
      //   if (this.DataQueue.length)
      //   {
      //     try {
      //       this.DropLatticeDataUpload();
      //     } catch (error) {
      //       console.log("error");
      //       console.log(error);
      //     }
      //   }
      // }, 50);
      this.loginData = SystemConfigModule.loginData;
      //新增上传落格回传上车数据处理线程,add by klm 20220909
      // this.timer = setInterval(() => {
      //   if (this.DataQueue.length)
      //   {
      //     try {
      //       this.DropLatticeDataUpload();
      //     } catch (error) {
      //       console.log("error");
      //       console.log(error);
      //     }
      //   }
      // }, 50);
    }

    //处理监控网关websocket返回事件，add by klm 2023-10-17
    private WebsocketDataFunc(receiveDataEventArgs)
    {
      try {

        let jsData = JSON.parse(receiveDataEventArgs);
        if (jsData.type == "9") {
          this.wcsUpdateWeight(jsData);
        } else if (jsData.type == "10") {
          this.wcsUpdateResultData(jsData);
        } else {
          LogHelper.WriteLog("收到其他类型的wcs推送:" + receiveDataEventArgs);
        }
      }
      catch (e) {
        console.log(e);
      }
    }


    //四段式发送重量
    private wcsUpdateWeight(jsData) {
      try{
        let waybillNo = jsData.data.waybillNo;
        waybillNo = waybillNo.toUpperCase().replace("R02T", "").replace("R02Z", "");

        let c = Enumerable.from(this.tableItems);
        let entity = c.firstOrDefault(f => f.code == waybillNo);
        if (!entity) {
          LogHelper.WriteLog("列表中未找到条码为" + waybillNo + "的行");
          return
        }
        entity.weight = jsData.data.weight;
        this.CountVo.totalWeight += parseFloat(jsData.data.weight);
      }catch (e) {
        console.log("函数wcsUpdateWeight异常");
      }
    }


    //四段式上传结果发送
    private wcsUpdateResultData(jsData) {
      try{
        let waybillNo = jsData.data.waybillNo;
        waybillNo = waybillNo.toUpperCase().replace("R02T", "").replace("R02Z", "");

        let c = Enumerable.from(this.tableItems);
        let entity = c.firstOrDefault(f => f.code == waybillNo);
        if (!entity) {
          return
        }
        if (jsData.data.code === "000") {
          entity.UploadStateName = "上传成功";
          entity.UploadStateCode = 1;
          if (jsData.data().nextWebPointName) {
            entity.NextWebPointName = jsData.data().nextWebPointName
          }
        } else {
          entity.UploadStateName = "上传失败";
          entity.UploadStateCode = 2;
        }
        entity.Info = jsData.data.msg;
        this.$forceUpdate();
      }catch (e) {
        console.log("函数wcsUpdateResultData异常");
      }
    }

    public async DropLatticeDataUpload(data)
    {
      try {
        console.log('start 8624:'+JSON.stringify(data))
        let signsure = obj_HttpRequest_Core.getSignature("8624", data.createTime);
        let _request = {
          mty: "8624",
          signature: signsure,//登录时需要获取的签名
          createTime: data.createTime,
          createUserCode: this.loginData.userCode,
          createUserName: this.loginData.userName,
          createOrgCode: this.loginData.orgCode,
          createOrgName: this.loginData.orgName,
          channel: "CV-PC",
          deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
          deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
          waybillNo: data.wayBillNo,
          latticeNo: data.latticeNo,
          latticeThreeCode:data.latticeThreeCode,
          cartNo: BizUtil.getCarNo(data),
          extend2: data.lattice_FLAG,
          schemeId: data.schemeId
        };
        let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
        let ret = false;
        if (stReturnStr?.code == "000")
        {
          ret = true;
        }
        else
        {
          ret = false;
        }
        //更新状态及线路、下一网点信息
        for (var i = 0; i < this.tableItems.length; i++) {
          if (this.tableItems[i].code == data?.wayBillNo) {

            this.$set(this.tableItems[i],'LineName',stReturnStr?.data.lineName)
            if (ret)
            {
              this.$set(this.tableItems[i],'UploadStateName2','上传成功')
            }
            else
            {
              this.$set(this.tableItems[i],'UploadStateName2',stReturnStr.msg)
            }
            break;
          }
        }
      }
      catch (e) {

      }
    }

    refreshCameraState() {
      let json = obj_DeviceItems_Core.getRefreshCameraState();
      this.deviceItems = JSON.parse(json);
    }


    private SetTaskWsPort() {
      console.log('start dws task ws')
      this.ws2 = new WebSocket(`ws://localhost:40998/`);
      var _this = this;
      this.ws2.onopen = () => {
        console.log('opened dws task ws')
      };
      this.ws2.onmessage = function (e) {
        if (!e.data) {
          return;
        }
        console.log('dws ws receive data:' + e.data);
        var obj = JSON.parse(e.data);
        if (obj.ActionName === 'summaryClose') {
          var data = JSON.parse(obj.Parameter);
          _this.summaryClose(data.weight, data.num)
        }
        if (obj.ActionName === 'InsertDataToListFun') {
          _this.InsertDataToListFunWs(obj.Parameter)
        }
        if (obj.ActionName === 'DataUploadCallback') {
          var data = JSON.parse(obj.Parameter);
          _this.UploadCallback(data.code, data.status, data.msg, data.nextWebPointName, data.containerNo)
        }
        if (obj.ActionName === 'SetErrorMsg') {
          _this.setFocus();
          _this.msg = obj.Parameter;
          ScanforOutBound_GetOffModule.setErrorMessage(obj.Parameter);
        }

        if (obj.ActionName === 'DropLatticeData') {
          _this.ReceiveDropData(JSON.parse(obj.Parameter));
        }

        if (obj.ActionName === 'WebSocketData') {
          _this.WebsocketDataFunc(JSON.parse(obj.Parameter));
        }
      };
      // this.msgWs = new WebSocket('ws://localhost:40997/');
      // this.msgWs.onmessage = function (evt) {
      //   if (evt.data) {
      //     var obj = JSON.parse(evt.data);
      //     if (obj.ActionName === 'SetErrorMsg') {
      //       _this.setFocus();
      //       _this.msg = obj.Parameter;
      //     }
      //   }
      // }
    }
    private ReceiveDropData(receiveDataEventArgs)
    {
      try {
        //六面扫上车数据异步上传,add by klm 20230919
        var data = JSON.parse(JSON.parse(receiveDataEventArgs).JsonData);
        var threeCode = "";
        // for (var i = 0; i < this.showList.length; i++) {
        //   if (this.showList[i].strCode == data.code) {
        //     threeCode = this.showList[i].Extend5ThreeCode;
        //     break;
        //   }
        // }
        let code = data.code.replace("R02T", "").replace("R02Z", "");
        threeCode = this.codeAndLatticeThreeCode.filter((item) => {
          return item.key == code;
        })[0].value;
        this.DropLatticeDataUpload2({
            wayBillNo: data.code,
            createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
            latticeNo: data.latticeNo,
            latticeThreeCode:threeCode
        })
        // this.DataQueue.unshift({
        //   wayBillNo: data.code,
        //   createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
        //   latticeNo: data.latticeNo,
        //   latticeThreeCode:threeCode
        // });

      }
      catch (e) {
console.log(e)
      }
    }

    private DropLatticeDataUpload2(data){
      let signsure = obj_HttpRequest_Core.getSignature("8624", data.createTime);
      let _request = {
        mty: "8624",
        signature: signsure,//登录时需要获取的签名
        createTime: data.createTime,
        createUserCode: this.loginData.userCode,
        createUserName: this.loginData.userName,
        createOrgCode: this.loginData.orgCode,
        createOrgName: this.loginData.orgName,
        channel: "CV-PC",
        deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
        deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
        waybillNo: data.wayBillNo,
        latticeNo: data.latticeNo,
        latticeThreeCode:data.latticeThreeCode,
        // cartNo: getCarNo(data),
      };
      let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
      (clientOptLog([data.wayBillNo],[data.latticeNo,data.latticeThreeCode,_request.deviceNo,_request.deviceType],'8053'));
      let ret = false;
      if (stReturnStr?.code == "000")
      {
        ret = true;
      }
      else
      {
        ret = false;
      }
    }

    //没有用到且有冲突
    // private DropLatticeDataUpload()
    // {
    //   try {
    //     if (this.DataQueue.length > 0){
    //       let data = this.DataQueue.pop();
    //       debugger;
    //       let signsure = obj_HttpRequest_Core.getSignature("8624", data.createTime);
    //       let _request = {
    //         mty: "8624",
    //         signature: signsure,//登录时需要获取的签名
    //         createTime: data.createTime,
    //         createUserCode: this.loginData.userCode,
    //         createUserName: this.loginData.userName,
    //         createOrgCode: this.loginData.orgCode,
    //         createOrgName: this.loginData.orgName,
    //         channel: "CV-PC",
    //         deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
    //         deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
    //         waybillNo: data.wayBillNo,
    //         latticeNo: data.latticeNo,
    //         latticeThreeCode:data.latticeThreeCode
    //       };
    //       let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
    //       (clientOptLog([data.wayBillNo],[data.latticeNo,data.latticeThreeCode,_request.deviceNo,_request.deviceType],'8053'));
    //       let ret = false;
    //       if (stReturnStr?.code == "000")
    //       {
    //         ret = true;
    //       }
    //       else
    //       {
    //         ret = false;
    //       }
    //       // //更新状态及线路、下一网点信息
    //       // for (var i = 0; i < this.showList.length; i++) {
    //       //   if (this.showList[i].strCode == data?.wayBillNo) {
    //       //
    //       //     this.showList[i].LineName = stReturnStr?.data.lineName;
    //       //     this.showList[i].NextOrgCode = stReturnStr?.data.nextOrgName;
    //       //     if (ret)
    //       //     {
    //       //       this.showList[i].state = "上传成功";
    //       //
    //       //     }
    //       //     else
    //       //     {
    //       //       this.showList[i].state = "上传失败";
    //       //       this.showList[i].Info = stReturnStr.msg;
    //       //     }
    //       //     break;
    //       //   }
    //       // }
    //     }
    //   }
    //   catch (e) {
    //
    //   }
    // }


    private InsertDataToListFunWs(parameter) {
      var data = JSON.parse(parameter);
      if (data.Items) {
        this.tableItems = data.Items;
      }
      if (data.item) {
        this.tableItems.splice(0, 0, data.item);
        if (this.tableItems.length > 10) {
          this.tableItems.pop();
        }
      }

      console.log("229" +  data.item.code);



      this.summaryClose(data.weight, data.num);

      if (ScanforOutBound_GetOffModule.isSixScanMode)
      {
        this.SetCountDisplay(data.item);
      }

      debugger;
      if (data?.latticeThreeCode !== "")
      {
        this.codeAndLatticeThreeCode.unshift({key: data.item.code, value: data.latticeThreeCode})
        if (this.codeAndLatticeThreeCode.length > 50)
        {
          this.codeAndLatticeThreeCode.pop();
        }
      }
    }

    //设置统计数据
    private SetCountDisplay(item)
    {
      debugger;
        if(item.code.toUpperCase() == "NOREAD")
        {
          this.noReadNum++;
          ScanforOutBound_GetOffModule.setNoReadLablel(this.noReadNum);
        }
        else if (item.code.includes("-"))
        {
          this.manyCodeNum++
          ScanforOutBound_GetOffModule.setManyCodeLabel(this.manyCodeNum);
        }
        else if (item.Str9 == null || item.Str9 == "")
        {
          this.noLittleNum++;
          ScanforOutBound_GetOffModule.setNoLittleNoLabel(this.noLittleNum);
        }
        else
        {
          this.littleNum++;
          ScanforOutBound_GetOffModule.setLittleNoLabel(this.littleNum);
        }

        var codeRate = 1 - this.noReadNum / this.CountVo.totalCount;
        var ret = (codeRate * 100).toFixed(2) + '%';
        ScanforOutBound_GetOffModule.setOverTimeLabel(ret);
    }

    private msg = "";
    private deviceItems: deviceItem[] = [];
    private ioTypes: ioTypes_Array_Data[] = [];

    private UploadCallback(code: string, status: boolean, msg: string, nextWebPointName: string, containerNo?: string) {
      let c = Enumerable.from(this.tableItems);
      let entity = c.firstOrDefault(f => f.code == code);
      if (!entity) {
        return
      }
      if (status) {
        entity.UploadStateName = "上传成功";
        entity.UploadStateCode = 1;
        if (nextWebPointName) {
          entity.NextWebPointName = nextWebPointName
        }
      } else {
        entity.UploadStateName = "上传失败";
        entity.UploadStateCode = 2;
        // entity.Info = msg;
      }
      entity.Info = msg;
      if (containerNo) {
        entity.CarSignNum = containerNo;
      }
      this.$forceUpdate()
      // entity.UploadStateName = "";
    }

    private VolInfoCallback(code,length,width,height){
      try {
        console.log("收到数据：" + code + ":" + length + ":" + width + ":" + height);
        let c = Enumerable.from(this.tableItems);
        let entity = c.firstOrDefault(f => f.code == code);
        if (!entity) {
          return
        }
        //单边大于40，或者三边之和大于90时显示
        if (length > 40 || width > 40 || height > 40 || (length + width + height) > 90)
        {
          entity.length = length;
          entity.height = height;
          entity.width = width;
        }
      }
      catch (ex) {
        console.log(ex)
      }
    }

    private summaryClose(weight: any, num: number) {
      console.log('summaryClose:' + weight + '----' + num)
      if (num > 0) {
        if (null == weight) {
          weight = 0;
        }
        this.CountVo.totalWeight += parseFloat(weight);
        this.CountVo.totalCount++;
        this.CountVo.currentCount++;
      } else {
        this.CountVo.totalWeight -= parseFloat(weight);
        if (this.CountVo.totalWeight < 0) {
          this.CountVo.totalWeight = 0
        }
        this.CountVo.totalCount--;
        this.CountVo.currentCount--;
        if (this.CountVo.totalCount < 0) {
          this.CountVo.totalCount = 0;
        }
        if (this.CountVo.currentCount < 0) {
          this.CountVo.currentCount = 0;
        }
      }
    }

    //上传成功,为黑色，其他都是红色
    private rowClassAction(row) {
      if (/失败/.test(row.row.UploadStateName)) {
        return {color: "#f22613", "font-size": "130%", "font-weight": "bold"};
      }
    }

    private ytoRowDbCLick(row, column, event) {
      console.log(row);
      this.ytoCode = row.code;
      this.f1.PacketCode = row.code;
    }

    private autoGetDataTimer = null;

    private autoGetData() {
      this.autoGetDataTimer = setTimeout(() => {
        var json = obj_ScanForOutbound_GetOff.getDataList();
        this.tableItems = eval(json);
        clearTimeout(this.autoGetDataTimer);
        this.autoGetData()
      }, 1000)
    }

    private setScanAreaTextErrorFun(code: string, msg: string) {
      this.ytoCode = code;
      let scan: any = this.$refs.scan;
      scan.setFocus();
      scan.selectInput();
      this.msg = msg;
      ScanforOutBound_GetOffModule.setErrorMessage(msg);
    }

    private config = config;
    private buttonVo: ButtonListVo = {
      DelButtonDisable: false,
      SaveButtonDisable: true,
      SubmitButtonDisable: false,
      UpdateButtonDisable: false
    };
    private f1: OnCodeGetReqVo = {
      CkOverWeightPromot: false,
      WeightDisable: true,
      NextWebPointDisable: false, RecvTypeLock: false,
      IsNeedWeight: true,
      NextWebPointLock: false,
      LWHDisable: false,
      setOptAreaRequired: false,
      IsNeedVoiceLayerDisable: false, PacketCode: "",
      NextOrgCode: "",
      PackageSize: {
        Length: 0,
        Width: 0,
        Height: 0,
        Weight: 0,
        InputWeight: 0,
        VolumnWeight: 0,
        LengthLock: false,
        WidthLock: false,
        HeightLock: false,
        InputWeightDisable: false,
      },
      CarSignNum: "",
      HasOperation: false,
      RecvType: "",
      NextWebPointName: "",
      NextWebPoint: "",
      IsNeedVoiceLayer: false,
      NeedWeight: false,
      AutoGetNextOrgCode: false,
      ReqIoType: {
        ChangeAddressType: "",
        ReturnType: ""
      },
      LockedCarSignNum: false,
      CarNumInfo: "",
      NotCheckReScan:false,
      IsNeedHKVoice: false,
      // AutoCreateCarCodeCheckBox:false
    };

    private async setInputForm() {
      return obj_ScanForOutbound_GetOff.setFormInput(this.f1)
    }

    private sendCountVo: sendCountVo = {notArrivingCount: 0, notSentCount: 0, visible: false};

    public ytoCode: string = '';

    private ytocodeget(code, e) {
      this.ytoCode = code;
      console.log(arguments);
      this.sendCountVo.visible = false;
      e.target.select();
      e.target.focus();
      this.msg = '';
      ScanforOutBound_GetOffModule.setErrorMessage("");
      if (ScanforOutBound_GetOffModule.autoCreateCarCode && this.ytoCode.length >= 10) {
        var rg = JSON.parse(checkCodesAndType(code.split(), "171",this.f1.CarSignNum));
        if (rg.ResultCode != 200)
        {
          ScanforOutBound_GetOffModule.setErrorMessage(rg.Info);
          return;
        }

        //如果扫描到车签
        if (rg.ResultCode == "200" && rg.Type == ApiQueryType.strCarCode) {
          ScanforOutBound_GetOffModule.setErrorMessage("已勾选自动生成车签功能，无法进行手动录入");
          return;
        }
      }
      obj_ScanForOutbound_GetOff.scanArea_KeyPress(this.ytoCode.toUpperCase(), this.f1.NextWebPointLock, this.f1.NextWebPoint);
    }

    private CountVo: CountingVo = {
      currentCount: 0,
      allCount: 0,
      totalCount: 0,
      totalWeight: 0,
      showProgress: true
    };

    public tableItems: QueueGetOffEntity[] = [];
    public tableItems2: ExpDetail_Array_Data[] = [];

    private currentDelRow = null;

    private delClick(row): void {
      ScanforOutBound_GetOffModule.setErrorMessage("");
      if (typeof obj_ScanForOutbound_GetOff.deleteClickNew !== "undefined") {
        if (row.UploadStateCode != UploadStateEnum.Sucess)
        {
          ScanforOutBound_GetOffModule.setErrorMessage("未上传，不能删除");
          return;
        }else{
          this.$confirm("是否确定要删除此数据？", "删除", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
          .then(() => {
            this.currentDelRow = row;
            obj_ScanForOutbound_GetOff.deleteClickNew(row);
          })
          .catch(() => {
            console.log("取消删除");
          });
        }
      }else{
        this.currentDelRow = row;
        obj_ScanForOutbound_GetOff.deleteClick(row);
      }
    }

    private scacInputDisable: boolean = false;

    private modifyClick(): void {
      var node: any = document.getElementById('input_scancode_id');
      var code = node.value;
      if (!code){
        code = this.ytoCode;
      }
      if (obj_ScanForOutbound_GetOff.modifyClick(code.toUpperCase())) {
        this.scacInputDisable = true;
        this.f1.PackageSize.InputWeightDisable = false;
      }
    }

    private saveClick(): void {
      this.f1.WeightDisable = false;
      this.scacInputDisable = false;
      this.f1.PackageSize.InputWeightDisable = true;
    }

    private submitClick(): void {
      obj_ScanForOutbound_GetOff.cancelClick();
    }
  }
